/* =============================================================================
   vp-newsletter-popup.js — Newsletter-Anmeldung im Pop-up
                                                    (05.09.2026, Fassung 3)

   Wunsch: Wer sich ueber das Pop-up anmeldet, soll nicht ans Seitenende
   geworfen werden und die Bestaetigung dort sehen, wo er gerade war.
   Die Anmeldung im Footer ist in Ordnung und bleibt unangetastet.

   ---------------------------------------------------------------------------
   WARUM OHNE NEULADEN NICHT GEHT — beide Wege gemessen, beide zu

   Fassung 2 hat versucht, das Formular per fetch abzuschicken, damit die Seite
   stehen bleibt. Das funktioniert nicht:

     POST /contact  ->  HTTP 400, <title>Missing CAPTCHA token</title>

   Shopify verlangt auf diesem Formular einen unsichtbaren CAPTCHA-Token. Den
   haengt Shopify erst beim NATIVEN Absenden an; auf der Seite selbst liegt
   dazu nichts bereit (nachgemessen: kein Captcha-Skript, keine Token-Felder,
   grecaptcha und hcaptcha nicht vorhanden). Ein fetch umgeht diesen
   Mechanismus und wird deshalb immer abgewiesen. Einen Token selbst zu
   beschaffen hiesse, eine Bot-Sperre auszuhebeln — das ist kein Weg.

   Der naheliegende zweite Weg, das Formular in ein verstecktes iframe zu
   schicken, ist ebenfalls versperrt. Die Storefront liefert

        X-Frame-Options: DENY
        Content-Security-Policy: frame-ancestors 'none'

   Nachgemessen an einer echten Antwort des Shops.

   Fazit: Das Neuladen ist nicht zu vermeiden. Diese Datei macht es deshalb so
   unauffaellig wie moeglich, statt es zu bekaempfen. (Ohne Neuladen ginge es
   nur ueber einen Anbieter mit eigener API, z. B. Klaviyo — dann landet der
   Abonnent aber dort und nicht als Shopify-Kunde mit dem Tag "newsletter".)

   ---------------------------------------------------------------------------
   BEFUND — was beim Neuladen schiefging

   1) DER SPRUNG INS SEITENENDE, zwei Ursachen.

      a) Das Kundenformular erzeugt in jeder Sektion dasselbe Markup:
           <form id="contact_form" action="/contact#contact_form" ...>
         Die ID kommt damit ZWEIMAL vor — Footer und Pop-up. Nach dem
         Absenden haengt der Browser den Anker an, und
         document.getElementById('contact_form') trifft das FOOTER-Formular
         (Position 10085px gemessen). Dagegen hilft, den Anker aus der Adresse
         des Pop-up-Formulars zu nehmen; das Footer-Formular behaelt seinen.

      b) form.posted_successfully? ist danach fuer ALLE Kundenformulare der
         Seite wahr, und die Erfolgsmeldung traegt autofocus. Der Browser
         springt also schon beim Parsen ins Footer-Formular — bevor
         irgendein Skript eingreifen kann. Das autofocus-Attribut nachtraeglich
         zu entfernen hilft nur, wenn man den Knoten frueh genug erwischt.
         Verlaesslich ist deshalb erst das Zurueckholen der Position.

      ACHTUNG, hier lag in Fassung 2 ein Fehler: restoreScroll() stieg mit
      `if (!(target > 0)) return` sofort aus, wenn die gemerkte Position 0 war.
      Wer das Pop-up oben auf der Seite ausfuellte — also der Normalfall —
      bekam gar keine Wiederherstellung und blieb im Footer stehen. Genau das
      war der gemeldete Fehler. Die Position 0 ist ein voellig gueltiges Ziel
      und wird jetzt genauso angesteuert wie jede andere.

   2) DIE WARTEZEIT. Nach dem Neuaufbau ist das Pop-up zu, und
      PromoPopup.init() stellt seinen Timer neu:
      setTimeout(openPopup, data-delay * 1000) mit data-delay = 30. Die
      Bestaetigung kam also erst eine halbe Minute spaeter. Deshalb wird das
      Pop-up hier selbst geoeffnet, sobald die Position steht.

   3) DER COOKIE. Den Wiedervorlage-Cookie setzt ausschliesslich closePopup().
      Wer sich anmeldet, schliesst nicht — es wurde also nie einer gesetzt,
      und das Pop-up meldete sich bei bereits Angemeldeten sieben Tage lang
      (data-frequency="168") weiter alle 30 Sekunden.

   ---------------------------------------------------------------------------
   ABLAUF

     1. Beim Absenden merkt sich die Seite Zeitstempel und Scroll-Position in
        der sessionStorage (Notiz 60 Sekunden gueltig). Das Formular wird NICHT
        abgefangen — kein preventDefault, kein fetch. Es geht genau so raus wie
        ohne diese Datei, damit Shopifys CAPTCHA-Mechanismus greift.
        Gleichzeitig wird der Button gesperrt und sichtbar auf "sendet"
        gestellt, damit aus einem Klick nicht drei Anmeldungen werden — siehe
        onSubmit().
     2. Nach dem Neuaufbau, wenn die Notiz vorliegt:
          - autofocus wird von den Erfolgsmeldungen genommen;
          - der Wiedervorlage-Cookie wird gesetzt, moeglichst bevor global.js
            das Element aufwertet — dann ueberspringt PromoPopup sein init();
          - die alte Position wird angesteuert, solange die Seite noch waechst
            (bis zu zwei Sekunden, in kurzen Schritten). Scrollt der Besucher
            selbst, wird sofort aufgehoert;
          - DANACH geht das Pop-up mit der Bestaetigung auf. Diese Reihenfolge
            ist noetig: ein offenes Pop-up setzt body.hidden und damit
            overflow: clip, dann laesst sich nicht mehr scrollen;
          - Eingabefeld, Haken und Button verschwinden (vp-newsletter-popup.css),
            sonst sieht es aus, als haette es nicht geklappt;
          - nach CLOSE_MS schliesst sich das Pop-up von selbst. So halten es
            Klaviyo, Privy und OptiMonk auch.
     3. Das automatische Oeffnen wird zusaetzlich stillgelegt, siehe
        popupStilllegen().

   Punkt 2 (Cookie) und 3 gelten NICHT im Theme-Editor, siehe entwurfsmodus().

   GELTUNGSBEREICH: nur form.promo-popup-newsletter-form. Footer-Formular,
   Sektion "Newsletter" und Menue-Schublade laufen unveraendert.

   TESTEN OHNE ECHTE ANMELDUNG: "?customer_posted=true" an die URL haengen und
   vorher sessionStorage.setItem('vpNewsletterFromPopup', Date.now()+':0')
   setzen — das ist genau der Zustand nach einer Anmeldung ueber das Pop-up.

   ZURUECKNEHMEN: die Zeilen fuer diese Datei und fuer vp-newsletter-popup.css
   in snippets/custom-assets.liquid entfernen.
   ========================================================================== */

(function () {
  'use strict';

  var POPUP_FORM = 'form.promo-popup-newsletter-form';
  var SUCCESS = '[id^="Newsletter-success"]';
  var ERROR = '[id^="Newsletter-error"]';
  var MARK = 'vpNewsletterFromPopup';
  var MAX_AGE = 60000;   // Notiz laenger als eine Minute ist nicht mehr gemeint
  var RESTORE_MS = 2000; // so lange wird die alte Position hoechstens angesteuert
  var CLOSE_MS = 4000;   // so lange bleibt die Bestaetigung stehen
  var ENTSPERR_MS = 20000; // Notbremse, falls die Navigation ausbleibt

  /* -------------------------------------------------------------------------
     Notiz ueber das Absenden
     --------------------------------------------------------------------- */

  // Notiz: "<Zeitstempel>:<Scroll-Position>"
  function note() {
    try {
      sessionStorage.setItem(MARK, Date.now() + ':' + Math.round(window.scrollY || 0));
    } catch (e) {}
  }
  function takeNote() {
    try {
      var v = sessionStorage.getItem(MARK);
      sessionStorage.removeItem(MARK);
      return v;
    } catch (e) { return null; }
  }

  var parts = (takeNote() || '').split(':');
  var stamp = parseInt(parts[0], 10);
  var savedY = parseInt(parts[1], 10) || 0;
  var fromPopup = stamp > 0 && (Date.now() - stamp) < MAX_AGE;

  /* -------------------------------------------------------------------------
     Gemeinsames
     --------------------------------------------------------------------- */

  // Im Theme-Editor darf nichts davon greifen. global.js macht es dort selbst
  // umgekehrt: closePopup() LOESCHT den Cookie im designMode, damit das Pop-up
  // beim Bearbeiten jedes Mal erscheint, und onSectionSelect() ruft openPopup()
  // auf, um es beim Anklicken der Sektion zu zeigen. Wuerde hier der Cookie
  // gesetzt oder openPopup stillgelegt, liesse sich die Sektion nicht mehr
  // aufklappen und waere nicht mehr zu bearbeiten.
  //
  // Lazy abgefragt und nicht einmalig gemerkt: diese Datei laedt mit async und
  // kann laufen, bevor content_for_header das Shopify-Objekt gesetzt hat.
  function entwurfsmodus() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function silenceTimer(el) {
    if (entwurfsmodus()) return;
    if (el.dataset.vpNlCookie) return;
    var name = el.getAttribute('data-section-id');
    var hours = parseInt(el.getAttribute('data-frequency'), 10);
    if (!name || !(hours > 0)) return;
    el.dataset.vpNlCookie = '1';
    // Gleiches Format wie PromoPopup.setCookie in global.js
    document.cookie = name + '=true; max-age=' + (hours * 3600) + '; path=/';
  }

  // DER ZWEITE AUFTRITT.
  //
  // Der Timer aus PromoPopup.init() prueft den Cookie NICHT noch einmal:
  //
  //   setTimeout(() => {
  //     if (!document.body.classList.contains('hidden')) this.openPopup();
  //     else if (!this.getCookie(this.cookieName)) { ... }
  //   }, delayValue * 1000);
  //
  // Nur der Konstruktor fragt den Cookie ab, und der laeuft, sobald global.js
  // das Element aufwertet. Steht der Cookie erst danach, ist der Timer laengst
  // gestellt und das Pop-up kommt ein zweites Mal — mit der Bestaetigung
  // darin. Gemessen: auf bei 1s, vom Besucher zu bei 2s, ungefragt wieder auf
  // bei 31s.
  //
  // Das Rennen ist nicht zu gewinnen: global.js steht als viertes Skript im
  // Dokument, diese Datei als zwanzigstes. Mit defer waere sie noch spaeter,
  // mit async entscheidet der Ladezeitpunkt — mal so, mal so.
  //
  // Deshalb wird das automatische Oeffnen nach einer Anmeldung stillgelegt,
  // statt sich auf den Cookie zu verlassen. Es geht dabei keine
  // Bedienmoeglichkeit verloren: dieses Pop-up hat weder eine Sticky-Tab noch
  // einen [data-popup-toggle]-Knopf (nachgemessen: 0 Stueck), es laesst sich
  // ohnehin nicht von Hand oeffnen. Der Cookie wird trotzdem gesetzt — er ist
  // fuer die FOLGENDEN Seitenaufrufe zustaendig.
  function popupStilllegen(pop) {
    if (entwurfsmodus()) return;
    if (!pop || pop.dataset.vpNlStill) return;
    pop.dataset.vpNlStill = '1';
    try { pop.openPopup = function () {}; } catch (e) {}
  }

  /* -------------------------------------------------------------------------
     Formular vorbereiten
     --------------------------------------------------------------------- */

  // MEHRFACHE ANMELDUNGEN — der zuletzt gemeldete Fehler.
  //
  // Gemessen an der Startseite: der POST auf /contact ist nach 119 ms durch,
  // die Antwort der Folgeseite nach rund 1 s. Interaktiv wird diese Seite aber
  // erst nach 8,9 s, DOMContentLoaded bei 18,9 s — sie bringt 1.131 KB HTML,
  // 173 Requests und 9,2 MB mit. Bis dahin steht die ALTE Seite unveraendert
  // im Bild und der Button ist weiter anklickbar. Fuer den Besucher sieht es
  // aus, als sei nichts passiert; er klickt noch zweimal — und jeder Klick
  // ist eine eigene Anmeldung mit eigener Bestaetigungsmail.
  //
  // Fassung 2 hatte diese Sperre schon, sie hing aber am fetch-Zweig und ist
  // mit ihm zusammen entfallen. Hier steht sie unabhaengig davon.
  //
  // WICHTIG: der Button wird erst im naechsten Takt (setTimeout 0) gesperrt.
  // Ein bereits disabled Button wird nicht mit serialisiert, und dieses
  // Formular schickt sein name="commit" mit. Zum Zeitpunkt des Timeouts sind
  // die Formulardaten laengst eingesammelt.
  function sperren(form) {
    form.setAttribute('aria-busy', 'true');
    var btn = form.querySelector('button[type="submit"]');
    if (btn) setTimeout(function () { btn.disabled = true; }, 0);
  }

  function entsperren(form) {
    delete form.dataset.vpNlSendet;
    form.removeAttribute('aria-busy');
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = false;
  }

  function onSubmit(event) {
    var form = event.currentTarget;
    if (form.dataset.vpNlSendet) {   // zweiter und dritter Klick laufen ins Leere
      event.preventDefault();
      return;
    }
    form.dataset.vpNlSendet = '1';
    note();          // Scroll-Position fuer nach dem Neuaufbau
    sperren(form);   // sichtbare Rueckmeldung, siehe vp-newsletter-popup.css
    // Bleibt die Navigation aus (Netzfehler, abgebrochen), soll der Besucher
    // es erneut versuchen koennen, statt vor einem toten Button zu sitzen.
    setTimeout(function () { entsperren(form); }, ENTSPERR_MS);
  }

  // Zurueck-Navigation: der Browser holt die Seite unveraendert aus dem
  // bfcache, samt gesperrtem Button. Hier wieder freigeben.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var f = document.querySelectorAll(POPUP_FORM);
    for (var i = 0; i < f.length; i++) entsperren(f[i]);
  });

  function prepareForm(form) {
    if (form.dataset.vpNlPrepared) return;
    form.dataset.vpNlPrepared = '1';
    // Ohne Anker kein Sprung ins Footer-Formular.
    var action = form.getAttribute('action') || '';
    if (action.indexOf('#') > -1) form.setAttribute('action', action.split('#')[0]);
    // Das Absenden selbst bleibt unangetastet — kein preventDefault beim
    // ersten Klick, sonst fehlt Shopify der CAPTCHA-Token (siehe Kopf).
    form.addEventListener('submit', onSubmit);
  }

  // Waehrend des Parsens nur eine billige Pruefung je Knoten — der Beobachter
  // sieht jedes Element der Seite, hier darf nichts Teures passieren.
  function watch(node) {
    if (node.nodeType !== 1 || !fromPopup) return;
    if (!node.id || node.id.indexOf('Newsletter-success') !== 0) return;
    if (node.hasAttribute('autofocus')) node.removeAttribute('autofocus');
    var pop = node.closest && node.closest('promo-popup');
    if (pop) silenceTimer(pop);
  }

  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) watch(added[j]);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function sweep(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll(POPUP_FORM);
    for (var i = 0; i < forms.length; i++) prepareForm(forms[i]);
    if (!fromPopup) return;
    var hits = scope.querySelectorAll(SUCCESS);
    for (var j = 0; j < hits.length; j++) watch(hits[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sweep(); });
  } else {
    sweep();
  }

  // Theme-Editor: nachgeladene Sektionen ebenfalls vorbereiten.
  document.addEventListener('shopify:section:load', function (e) {
    sweep(e.target && e.target.querySelectorAll ? e.target : document);
  });

  /* -------------------------------------------------------------------------
     Nach dem Neuladen: Position zurueck, Bestaetigung, dann zu
     --------------------------------------------------------------------- */

  // Das Theme setzt html { scroll-behavior: smooth }. Ein schlichtes
  // window.scrollTo(0, y) startet damit eine weiche Animation — und weil hier
  // im kurzen Takt nachgesteuert wird, wuerde jeder Ruf die vorherige
  // Animation abbrechen und die Seite kaeme nie an. Gemessen: mit der
  // Kurzform blieb scrollY auf 0, mit behavior 'instant' sprang sie sofort
  // auf 800. Also ausdruecklich ohne Animation springen.
  function springeZu(y) {
    try {
      window.scrollTo({ top: y, left: 0, behavior: 'instant' });
    } catch (e) {
      window.scrollTo(0, y); // sehr alte Browser kennen das Objekt nicht
    }
  }

  // Die Seite waechst nach dem Aufbau noch (Bilder, Videos, nachgeladene
  // Sektionen), und das autofocus im Footer zieht sie zwischendurch nach
  // unten. Deshalb in kurzen Schritten nachsteuern, statt einmal zu springen —
  // und sofort aufhoeren, sobald der Besucher selbst scrollt.
  //
  // Ziel 0 ist ausdruecklich erlaubt: das ist der haeufigste Fall, weil das
  // Pop-up meist oben auf der Seite ausgefuellt wird. Fassung 2 hatte hier ein
  // `if (!(target > 0)) return` und tat dann gar nichts — der Grund fuer den
  // gemeldeten Footer-Sprung.
  function restoreScroll(target, done) {
    var finished = false;
    var finish = function () { if (!finished) { finished = true; done(); } };
    if (!(target >= 0)) return finish();

    var abort = function () { finish(); };
    var events = ['wheel', 'touchstart', 'keydown'];
    events.forEach(function (t) {
      window.addEventListener(t, abort, { passive: true, once: true });
    });

    var start = Date.now();
    (function tick() {
      if (finished) return;
      var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      var goal = Math.min(target, max);
      if (Math.abs(window.scrollY - goal) > 2) {
        try { springeZu(goal); } catch (e) { finish(); return; }
      }
      if (Date.now() - start > RESTORE_MS) { finish(); return; }
      setTimeout(tick, 60);
    })();
  }

  // Nach der Bestaetigung schliesst sich das Pop-up von selbst — so machen es
  // Klaviyo, Privy und OptiMonk ebenfalls. Hat der Besucher schon selbst
  // geschlossen, passiert nichts mehr.
  function spaeterSchliessen(el) {
    setTimeout(function () {
      if (!document.querySelector('.popup-wrapper.open')) return;
      try { el.closePopup({ type: 'vp-auto' }); } catch (e) {}
    }, CLOSE_MS);
  }

  function showConfirmation() {
    var el = document.querySelector('promo-popup');
    if (!el || typeof el.openPopup !== 'function') return;
    var geschafft = el.querySelector(SUCCESS);
    if (!geschafft && !el.querySelector(ERROR)) return;

    // Formular VOR dem Oeffnen greifen: openPopup() haengt die .popup-wrapper
    // an den <body>, danach ist sie ueber el.querySelector() nicht mehr zu
    // finden. Genau daran blieb die Anmeldemaske vorher stehen.
    var form = el.querySelector(POPUP_FORM);

    try { el.openPopup(); } catch (e) { return; }

    if (form && geschafft) form.classList.add('vp-nl-fertig');

    var heading = document.querySelector('.popup-wrapper.open ' + SUCCESS) ||
                  document.querySelector('.popup-wrapper.open ' + ERROR);
    if (heading && heading.focus) {
      try { heading.focus({ preventScroll: true }); } catch (e) { /* aelterer Browser */ }
    }

    if (geschafft) {
      popupStilllegen(el);
      spaeterSchliessen(el);
    }
  }

  if (fromPopup && window.customElements && customElements.whenDefined) {
    customElements.whenDefined('promo-popup').then(function () {
      // Erst die Position, dann das Pop-up: ein offenes Pop-up sperrt das
      // Scrollen ueber body.hidden / overflow: clip.
      restoreScroll(savedY, function () {
        setTimeout(showConfirmation, 100);
      });
    });
  }
})();